import {hideToast} from "./action";


const hideToastAction = (idx) => hideToast(idx);

export default {
    hideToastAction
};
